module.exports = __webpack_public_path__ + "static/legend-placement-dont-55c78e3944e601df2261225b358285d7.png";